const networkingOverviewState = {
    networkingOverview: undefined,
    requestingNetworkingOverview: false
};
export default networkingOverviewState;
